import { render, staticRenderFns } from "./SuggestionList.vue?vue&type=template&id=7c769560"
import script from "./SuggestionList.vue?vue&type=script&lang=js"
export * from "./SuggestionList.vue?vue&type=script&lang=js"
import style0 from "./SuggestionList.vue?vue&type=style&index=0&id=7c769560&prod&lang=scss"
import style1 from "./SuggestionList.vue?vue&type=style&index=1&id=7c769560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports